import { request } from '@ps/web-core-api';
import type { HttpHeaders, RequestError, RequestOptions, StompHeaders } from '@ps/web-core-api';
import { canUseDOM } from '@ps/web-core-utils';
import { merge } from 'lodash';

import type { Store } from '../types';

import { WMTConnection } from './WMTConnection';

export const bindRequest =
  (store: Store): typeof request =>
  (options: RequestOptions) => {
    const connection = WMTConnection(store);
    const { select, getState, dispatch } = store;
    const rootState = getState();
    const embedded = select.device.isEmbedded(rootState);
    const device = select.device.getId(rootState);
    const os = select.device.getOS(rootState);
    const { token } = select.session.get(rootState);
    const currency = select.currency.get(rootState);
    const locale = select.locale.get(rootState);
    const { href, origin, host } = select.location.get(rootState);
    const platform = select.device.getPlatform(rootState);
    const headers: HttpHeaders = { referer: href, ['x-fi-ps-platform-id']: `${platform}` };
    const isSports = options.service.startsWith('/sports');
    // country
    // state
    // brand
    // site
    // timezone (HTTP only)
    // region (STOMP only)

    // if (sportsAPI && !canUseDOM && meta.systemState?.sports === 'red') {
    //   debug('sports request %s was rejected because the sports status is red', service);
    //   throw new VerticalStatusError(Vertical.Sports, service, method);
    // }

    if (token) {
      headers.authorization = `StarsWeb-Session ${token}`;
    }

    if (options.http) {
      headers['x-stars-currency'] = currency;
      headers['x-stars-locale'] = locale;
    } else {
      Object.assign(headers, { currency, locale } satisfies StompHeaders);
    }

    if (!canUseDOM && options.http) {
      headers['x-stars-embedded'] = embedded ? '1' : '0';
      headers['x-device'] = `${device}`;
      headers['x-os-family'] = `${os}`;
      headers['x-stars-currency'] = currency;
      headers['x-stars-locale'] = locale;
      headers['x-forwarded-host'] = host;
      headers.origin = origin;
    } else if (!canUseDOM) {
      const stompHeaders = headers as StompHeaders;
      stompHeaders.device = `${device}`;
      stompHeaders.os = `${os}`;
      stompHeaders.locale = locale;
      stompHeaders.embedded = embedded ? '1' : '0';
      stompHeaders['x-forwarded-host'] = host;
    }

    try {
      return request(merge({ headers, connection }, options));
    } catch (e) {
      const error = e as RequestError;

      if (isSports && error.body.code === 'MAINTENANCE') {
        dispatch.system.update({ body: { sports: 'red' } });
      }

      if (isSports && error.statusCode === 401) {
        const dispatchLoggedOutModal = () => dispatch.modal.enqueue({ path: '/sports/logged-out' });
        if (embedded) {
          document.addEventListener('starslogout', dispatchLoggedOutModal, { once: true });
          // window.starsweb?.auth.logout(); TODO types for starsweb embedded API
        } else {
          dispatch.auth.logout();
          dispatchLoggedOutModal();
        }
      }

      throw e;
    }
  };
